import React, { useState } from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import TrackingContext from './TrackingContext';

const track = (trackingPageName, wizardValues, onTrackingEvent, generateId) => (
  piggyEvent
) => {
  const { component, name, type } = piggyEvent;
  const eventId = generateId
    ? generateId({
        trackingPageName,
        componentName: name,
        componentType: component,
        eventType: type,
      })
    : `${trackingPageName}_${name}_${component}_${type}`;
  onTrackingEvent({ trackingPageName, piggyEvent, wizardValues, eventId });
};

const EventsProvider = (props) => {
  const { generateId, onTrackingEvent } = props;
  const [trackingPageName, setTrackingPageName] = useState('');
  const [wizardValues, setWizardValues] = useState({});

  return (
    <TrackingContext.Provider
      value={{
        trackingPageName,
        setTrackingPageName,
        track: track(
          trackingPageName,
          wizardValues,
          onTrackingEvent,
          generateId
        ),
        isTrackingInUse: true,
        setWizardValues,
      }}
    >
      {props.children}
    </TrackingContext.Provider>
  );
};

EventsProvider.propTypes = {
  children: PropTypes.node,
  generateId: PropTypes.func,
  onTrackingEvent: PropTypes.func.isRequired,
};

EventsProvider.defaultProps = {
  children: null,
  generateId: null,
  onTrackingEvent: noop,
};

export default EventsProvider;
